/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize content DashboardView.
 */

// Dependencies
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Redux Actions
import * as actions from '@nephro/redux/stores/app/actions';
import * as authActions from '@nephro/redux/stores/auth/actions';
import * as menuActions from '@nephro/redux/stores/menu/actions';
import * as patientActions from '@nephro/redux/stores/patient/actions';

// View
import View from './dashboardView';

/**
 * Map state to props
 * @returns { object }
 */
export const mapStateToProps = (state) => ({
  loading: state.getIn(['AppState', 'loading']),
  user: state.getIn(['AppState', 'user']),
  response: state.getIn(['AppState', 'response']).toJS()
});

/**
 * Map dispatch to props
 * @param dispatch - Run the  process to execute in the action
 * @returns { object }
 */
export const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
  patientActions: bindActionCreators(patientActions, dispatch),
  authActions: bindActionCreators(authActions, dispatch),
  menuActions: bindActionCreators(menuActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
